import * as React from "react";
import type { SVGProps } from "react";

interface MainProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const Main = ({ cancelled = false, ...props }: MainProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={66}
    height={66}
    viewBox="0 0 66 66"
    {...props}
  >
    <g>
    <g fill="none" fillRule="evenodd">
      <path
        fill="#C74D28"
        fillRule="nonzero"
        d="M20.493 17.823c12.72-10.525 28.6-12.032 35.468-3.366s2.124 24.224-10.597 34.749-28.6 12.032-35.467 3.366c-6.868-8.666-2.124-24.224 10.596-34.749"
      />
      <path
        fill="#FFF"
        d="M8.225 31.767q5.615 9.773 9.12 14.186 3.503 4.414 11.609 11.922l-8.99 2.265-14.23-19.212zm49.371 3.369q-5.615-9.774-9.119-14.187T36.867 9.027l8.99-2.265 14.23 19.213z"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="m41.411 17.424.095.118c.51.7.359 1.685-.337 2.198l-1.903 1.41-1.622 1.213c-4.741 3.562-8.345 6.426-10.798 8.58l-.44.391a169 169 0 0 0-9.183 8.9c-.6.623-1.588.64-2.208.037a1.58 1.58 0 0 1-.037-2.224 173 173 0 0 1 9.353-9.063l.982-.862.917-.781c3.085-2.597 7.444-5.972 13.094-10.138a1.554 1.554 0 0 1 2.087.221"
      />
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M16.639 32.244a.79.79 0 0 1 1.125.02l5.097 5.311a.81.81 0 0 1-.02 1.142.79.79 0 0 1-1.125-.02l-5.097-5.312a.81.81 0 0 1 .02-1.141m4.075-3.967a.79.79 0 0 1 1.125.04l5.003 5.4a.81.81 0 0 1-.04 1.14.79.79 0 0 1-1.124-.04l-5.003-5.4a.81.81 0 0 1 .04-1.14m4.134-3.495a.79.79 0 0 1 1.122.078l4.812 5.572a.81.81 0 0 1-.08 1.138.79.79 0 0 1-1.122-.078l-4.812-5.572a.81.81 0 0 1 .08-1.138m4.188-3.391a.79.79 0 0 1 1.122.078l4.812 5.572a.81.81 0 0 1-.08 1.139.79.79 0 0 1-1.122-.079l-4.812-5.571a.81.81 0 0 1 .08-1.14m4.188-3.26a.79.79 0 0 1 1.122.078l4.812 5.571a.81.81 0 0 1-.08 1.14.79.79 0 0 1-1.122-.08l-4.812-5.57a.81.81 0 0 1 .08-1.14"
      />
      <g strokeLinejoin="round" transform="rotate(50 35.21 31.049)">
        <ellipse
          cx={35.609}
          cy={34.388}
          stroke="#FFF"
          strokeWidth={3}
          rx={21.387}
          ry={31.297}
        />
        <ellipse
          cx={35.609}
          cy={34.388}
          stroke="#000"
          strokeWidth={2}
          rx={20.887}
          ry={30.797}
        />
      </g>
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default Main;
